var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tuango-base-line-chart',{attrs:{"provider":_vm.dataProvider,"title":"Claims"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de80bf3a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/happypack/loader.js?id=eslint!./src/app/pages/Metrics/Claims.vue
// module id = 723
// module chunks = 1